import axios from 'axios';

const instance = axios.create();

const setAuth = (token) => {
	instance.defaults.headers.common.Authorization = token;
};

export default instance;
export { setAuth };
